(function () {
	const selectors = {
		item: ".collapsible-rows__item",
		toggle: ".collapsible-rows__toggle",
		content: ".collapsible-rows__content",
		items: ".collapsible-rows__items",
	};

	const setExpanded = (item, expanded) => {
		const toggle = item.querySelector(selectors.toggle);
		const content = item.querySelector(selectors.content);

		if (!toggle || !content) return;

		toggle.setAttribute("aria-expanded", expanded ? "true" : "false");
		item.classList.toggle("active", expanded);

		if (expanded) {
			content.style.maxHeight = `${content.scrollHeight}px`;
		} else {
			content.style.maxHeight = `${content.scrollHeight}px`;
			content.offsetHeight;
			content.style.maxHeight = "0px";
		}
	};

	const initCollapsibleRows = (scope = document) => {
		scope.querySelectorAll(selectors.item).forEach((item) => {
			const toggle = item.querySelector(selectors.toggle);
			const content = item.querySelector(selectors.content);

			if (!toggle || !content) return;

			if (item.classList.contains("active")) {
				content.style.maxHeight = `${content.scrollHeight}px`;
				toggle.setAttribute("aria-expanded", "true");
			}

			if (toggle.dataset.collapsibleRowsStarted === "true") return;
			toggle.dataset.collapsibleRowsStarted = "true";

			toggle.addEventListener("click", () => {
				const isExpanded = item.classList.contains("active");
				const list = item.closest(selectors.items);

				if (list) {
					list.querySelectorAll(`${selectors.item}.active`).forEach((openItem) => {
						if (openItem !== item) {
							setExpanded(openItem, false);
						}
					});
				}

				setExpanded(item, !isExpanded);
			});
		});

		scope.querySelectorAll(selectors.item).forEach((item) => {
			if (item.dataset.collapsibleRowsHoverStarted === "true") return;
			item.dataset.collapsibleRowsHoverStarted = "true";

			item.addEventListener("mouseenter", () => {
				const list = item.closest(selectors.items);
				if (!list) return;

				list.querySelectorAll(selectors.item).forEach((sibling) => {
					if (sibling !== item) {
						sibling.classList.add("collapsible-rows__item--opacity");
					}
				});
			});

			item.addEventListener("mouseleave", () => {
				const list = item.closest(selectors.items);
				if (!list) return;

				list.querySelectorAll(selectors.item).forEach((sibling) => {
					sibling.classList.remove("collapsible-rows__item--opacity");
				});
			});
		});
	};

	document.addEventListener("DOMContentLoaded", () => {
		initCollapsibleRows();
	});

	document.addEventListener("shopify:section:load", (event) => {
		initCollapsibleRows(event.target);
	});

	window.addEventListener("resize", () => {
		document
			.querySelectorAll(`${selectors.item}.active ${selectors.content}`)
			.forEach((content) => {
				content.style.maxHeight = `${content.scrollHeight}px`;
			});
	});
})();
